import { Flex } from "@chakra-ui/react";
import React, { useState } from "react";

import { ApiGmwGmwsListRequest } from "@nens/brostar/openapi-client";

import { getSearchKey } from "@/components/searchbox";
import { useRouterTableData } from "@/hooks/use-router-table-data";

import { FilterWrapper } from "../../components/filter-wrapper";

import { GmwFilters } from "./components/gmw-filters";
import { GmwContext } from "./contexts/gmw-context";
import { MainMap } from "./features/map";
import { MonitoringTubeTable } from "./features/monitoring-tube";
import { GmwTable } from "./features/table";
import { GMWFiltersByGMN, GMWSFilters, SelectedGmw, gmwInformation } from "./types";

type Props = {
  mode: "map" | "table";
  monitoringTubeSelectionTable?: never;
  excelMeasuringPoints?: never;
};

type SelectMonitoringTubeProps = {
  mode: "map";
  monitoringTubeSelectionTable: React.ReactElement;
  excelMeasuringPoints: React.ReactElement;
};

export function GmwView({
  mode,
  monitoringTubeSelectionTable,
  excelMeasuringPoints,
}: Props | SelectMonitoringTubeProps) {
  const {
    page,
    setPage,
    searchField: _searchField,
    searchString,
    setSearchField,
    setSearchString,
  } = useRouterTableData({ keyAddon: "GMW" });
  const searchField =
    (_searchField as keyof ApiGmwGmwsListRequest | undefined) || getSearchKey(gmwInformation[0]);
  const [gmwFiltersByGMN, _setGmwFiltersByGMN] = useState<GMWFiltersByGMN>({});
  const [selectedGmw, setSelectedGmw] = useState<SelectedGmw | undefined>(undefined);

  const setGmwFiltersByGMN = (partial: Partial<GMWFiltersByGMN>) => {
    _setGmwFiltersByGMN((prev) => ({ ...prev, ...partial }));
  };

  const gmwFilters: GMWSFilters = {
    ...gmwFiltersByGMN,
    page,
    search: {
      searchString,
      searchField,
    },
  };
  return (
    <GmwContext.Provider
      value={{ selectedGmw, setPage, setSelectedGmw, gmwFilters, setGmwFiltersByGMN }}
    >
      <FilterWrapper>
        <GmwFilters
          showGmnFilter={mode !== "map"}
          {...{ searchField, setSearchField, searchString, setSearchString }}
        />
        {excelMeasuringPoints}
      </FilterWrapper>

      <Flex
        h={monitoringTubeSelectionTable ? "661px" : "full"}
        display={mode === "map" ? "flex" : "none"}
      >
        <MainMap />
        {monitoringTubeSelectionTable || <MonitoringTubeTable />}
      </Flex>

      {mode === "table" && !monitoringTubeSelectionTable && <GmwTable />}
    </GmwContext.Provider>
  );
}
